import React, {Component} from "react";
import {Button, Col, Form} from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";
// Contexto
import {levelTeams} from "../../../contexto";

export default class FormGrupoTrabajo extends Component {
  constructor(props) {
    super(props);
    //Una variable controla si esta relleno o no el campo de los pdf o fotos
    //La otra controla si el campo esta vacio porque ha sido eliminado o porque el usuairo no ha metido ese pdf
    this.state = {
      photo: false,
      addPhoto: true,
    };
    this.setInformacionOrganismo = this.setInformacionOrganismo.bind(this);
  }

  componentDidMount() {
    let photo = this.props.DatosGrupoTrabajo.photo !== "/images/logoSTJ.png";

    this.setState({
      photo: photo,
    });
  }

  // Función que hace el put a los datos personales de la monja
  async setInformacionOrganismo(event) {
    event.preventDefault();
    let $this = $(this);
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);
    //console.log(myform)

    if (event.target["photo"]) {
      if (event.target["photo"].value) {
        this.setState({
          photo: true,
        });
      }
    }

    //console.log(process.env.REACT_APP_API_URL + "/provincias/" + $this[0].props.id_provincia + "/gruposTrabajo/" + $this[0].props.DatosGrupoTrabajo.id)
    let settings = {
      
      url: process.env.REACT_APP_API_URL + "/provincias/" + $this[0].props.id_provincia + "/gruposTrabajo/" + $this[0].props.DatosGrupoTrabajo.id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    await $.ajax(settings)
      .done(async function (response) {
        response = JSON.parse(response);
        $this[0].props.setInformacionOrganismo(response);
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");

        if (!$this[0].state.photo && !$this[0].state.addPhoto) {
          await utils.callAjaxGet(
            "DELETE",
            process.env.REACT_APP_API_URL + "/download/provincias/" + $this[0].props.id_provincia + "/gruposTrabajo/" + $this[0].props.DatosGrupoTrabajo.id,
            $this[0].props.ErrorHandling
          );
          $this[0].props.nullField("photo", "photo");
        }

        $this[0].setState({
          addPhoto: true,
        });
      })

      .fail($this[0].props.ErrorHandling);

    // Hacemos el post a finalidad
    let myform2 = document.getElementById("MyFormCheck");
    let form2 = new FormData(myform2);
    let propositoRemove = ["Escolar", "Economía", "PJVT", "Formación", "Social", "Espiritualidad", "Salud", "MTA", "Pastoral", "Enfermerías", "Familia Teresiana", "Comunicación", "Servicios eclesiales","Otro"];
    let propositoAdd = [];

    let indice = 0;
    // Creamos el json en funcion de esto y lo enviamos
    if (this?.props?.DatosGrupoTrabajo?.provinceId === '14') {
      for (let pair of form2.entries()) {
        propositoAdd.push(pair[1]);
      }
    } else {
      for (let pair of form2.entries()) {
        indice = propositoRemove.indexOf(pair[0]);
        if (indice !== -1) {
          propositoAdd.push(pair[0]);
          propositoRemove.splice(indice, 1);
        }
      }
    }

    let obj = {
      propositoRemove,
      propositoAdd,
    };

    let settings2 = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + $this[0].props.id_provincia + "/gruposTrabajo/" + $this[0].props.DatosGrupoTrabajo.id + "/propositos",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: "application/json",
      data: JSON.stringify(obj),
    };

    await $.ajax(settings2)
      .done(async function () {
        $this[0].props.setFinalidad();
      })
      .fail($this[0].props.ErrorHandling);
  }

  checkDefaultChecked(event) {
    let boolean = false;
    for (let i = 0; i < this.props.Finalidad.length; i++) {
      if (this.props.Finalidad[i].type === event) boolean = true;
    }
    return boolean;
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();
    // const photo = this.state.photo ? (
    //   <Form.Group>
    //     <a href={process.env.REACT_APP_API_URL + "/provincias/" + this.props.id_provincia + "/gruposTrabajo/" + this.props.DatosGrupoTrabajo.id} target="_blank" rel="noreferrer">
    //       Foto
    //     </a>
    //     <Button
    //       variant="light"
    //       className="ml-3"
    //       onClick={() =>
    //         this.setState({
    //           photo: false,
    //           addPhoto: false,
    //         })
    //       }
    //     >
    //       <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
    //     </Button>
    //   </Form.Group>
    // ) : (
    //   <Form.Group>
    //     <Form.Label>Foto</Form.Label>
    //     <Form.Control type="file" name="photo" />
    //   </Form.Group>
    // );

    return (
      <Form className=" p-4" onSubmit={this.setInformacionOrganismo} id="MyForm" autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Nombre Equipo/Comisión *</Form.Label>
          <Form.Control required type="text" name="name" maxLength="90" autoComplete="nope" defaultValue={this.props.DatosGrupoTrabajo.name} />
        </Form.Group>

        <Form.Group>
          <Form.Label>Fecha de Creación *</Form.Label>
          <Form.Control required type="date" name="creationDate" max={today} autoComplete="nope" defaultValue={this.props.DatosGrupoTrabajo.creationDate} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Cierre</Form.Label>
          <Form.Control type="date" name="endDate" max={today} autoComplete="nope" defaultValue={this.props.DatosGrupoTrabajo.endDate} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Email *</Form.Label>
          <Form.Control required type="email" name="email" autoComplete="nope" defaultValue={this.props.DatosGrupoTrabajo.email} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Tipo *</Form.Label>
          <Form.Control required autoComplete="nope" as="select" name="type" defaultValue={this.props.DatosGrupoTrabajo.type}>
            <option>Equipo</option>
            <option>Comisión</option>
          </Form.Control>
        </Form.Group>
        {this?.props?.DatosGrupoTrabajo?.provinceId === '14' && (
          <Form.Group>
            <Form.Label>Nivel *</Form.Label>
            <Form.Control required autoComplete="nope" as="select" name="level" defaultValue={this.props.DatosGrupoTrabajo.level}>
              {levelTeams.map((level) => (
                <option value={level} key={level}>
                  {level}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        )}

        <Form id="MyFormCheck" className="my-3">
          <Form.Label>Finalidad del equipo</Form.Label>
          {this?.props?.DatosGrupoTrabajo?.provinceId === '14' ?

            <Form.Control label="proposito" type="text" name="finalidad" maxLength="200" autoComplete="nope"
              defaultValue={this.props.Finalidad.length > 0 ? this.props.Finalidad[0].type : ""} />
            :
            <Form.Row>
              <Col lg="6">
                <Form.Check label="Escolar" name="Escolar" />
                <Form.Check label="Economía" name="Economía" />
                <Form.Check label="PJVT" name="PJVT" />
                <Form.Check label="Formación" name="Formación" />
                <Form.Check label="Social" name="Social" />
                <Form.Check label="Espiritualidad" name="Espiritualidad" />
              </Col>
              <Col lg="6">
                <Form.Check label="Salud" name="Salud" />
                <Form.Check label="MTA" name="MTA" />
                <Form.Check label="Pastoral" name="Pastoral" />
                <Form.Check label="Enfermerías" name="Enfermerías" />
                <Form.Check label="Familia Teresiana" name="Familia Teresiana" />
                <Form.Check label="Comunicación" name="Comunicación" />
                <Form.Check label="Servicios eclesiales" name="Servicios eclesiales" />
              </Col>
              <Col lg="6">
              <Form.Check label="Otro" name="Otro" />
              </Col>
            </Form.Row>
          }
        </Form>

        {/* {photo} */}
        <Form.Group>
          <Button type="submit" variant="outline-success" className="btn btn-block mt-5" name="Datos Canonicos">
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
